"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LocationFilterManager = require("./LocationFilterManager");

var _LocationSortingManager = _interopRequireDefault(require("./LocationSortingManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LocationManager = /*#__PURE__*/function () {
  function LocationManager() {
    _classCallCheck(this, LocationManager);

    /**
     * @type {LocationFilterManager}
     * @private
     */
    this.filterManager = new _LocationFilterManager.LocationFilterManager();
    this.sortingManager = new _LocationSortingManager["default"]();
  }
  /**
   * @param {Location[]} locations
   * @param {Location} sortLocation
   * @param {Location} userLocation
   */


  _createClass(LocationManager, [{
    key: "sort",
    value: function sort(locations, sortLocation, userLocation) {
      var _this = this;

      var filteredLocations = locations.filter(function (location) {
        return _this.filterManager.compare(location);
      });
      return this.sortingManager.sort(filteredLocations, sortLocation, userLocation);
    }
  }, {
    key: "addFilter",
    value: function addFilter(filter) {
      this.filterManager.addFilter(filter);
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      this.filterManager.removeFilter(filter);
    }
  }, {
    key: "resetFilters",
    value: function resetFilters(filter) {
      this.filterManager.resetFilters(filter);
    }
  }]);

  return LocationManager;
}();

var _default = LocationManager;
exports["default"] = _default;